/**
 * Ensures camera (and mic) permission is requested on Android when running in Tauri.
 * Call before starting camera or opening camera settings so the host app can request runtime permission;
 * after this, getUserMedia in the WebView is more likely to succeed.
 */

import { isInTauriShell } from './detector'
import { getRuntimeInfo } from './getRuntimeInfo'
import { invokeTauri } from './bridge'

export async function ensureCameraPermission(): Promise<void> {
  if (!isInTauriShell()) return
  const info = await getRuntimeInfo()
  if (info.platform !== 'android') return
  try {
    await invokeTauri('request_camera_permission')
  } catch (err) {
    console.warn('[ensureCameraPermission] request_camera_permission failed:', err)
  }
}
